import React from 'react';
import { withTranslation } from 'react-i18next';

import { Box, Container, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import OverrideTheme from 'themes/custom-theme-helper';

const useStyles = makeStyles(() => ({
  footer: {
    backgroundColor: OverrideTheme.colors.background,
  },
}));

const Footer = (): JSX.Element => {
  const classes = useStyles();
  return (
    <Box p={2} className={classes.footer}>
      <Container maxWidth="xl">
        <Box px={3} className={classes.footer}>
          <Grid container>
            <Grid item md={6}>
              <Typography color="textSecondary" align="left">
                {new Date().getFullYear()} © Actual group. Informations
                confidentielles à vocation interne uniquement.
              </Typography>
            </Grid>
            <Grid item md={6}>
              <Typography color="textSecondary" align="right">
                Développé avec
                <Box component="span" display="inline" mx={1}>
                  ❤
                </Box>
                par la Digital Factory
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default withTranslation()(Footer);
